function updateUrlParameter(uri, key, value) {
    // remove the hash part before operating on the uri
    const i = uri.indexOf('#');
    const hash = i === -1 ? ''  : uri.substr(i);
    uri = i === -1 ? uri : uri.substr(0, i);

    const re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
    const separator = uri.indexOf('?') !== -1 ? "&" : "?";

    if (!value) {
        // remove key-value pair if value is empty
        uri = uri.replace(new RegExp("([?&]?)" + key + "=[^&]*", "i"), '');
        if (uri.slice(-1) === '?') {
            uri = uri.slice(0, -1);
        }
        // replace first occurrence of & by ? if no ? is present
        if (uri.indexOf('?') === -1) uri = uri.replace(/&/, '?');
    } else if (uri.match(re)) {
        uri = uri.replace(re, '$1' + key + "=" + value + '$2');
    } else {
        uri = uri + separator + key + "=" + value;
    }
    return uri + hash;
}

function updateFilterBtnText() {
    const total_filters = $('.specialties-div li.active').length + $('.preferences-div li.active').length + $('.languages-div li.active').length + $('.identities-div li.active').length;
    if (total_filters > 0) {
        $('.filter-btn .label').text("Filter by (" + total_filters + ")");
    }
}

document.addEventListener("DOMContentLoaded", () => {
    updateFilterBtnText();
});

$(document).ready(function() {
     function initMultiselect({ selectId, selectedOptions, buttonLabel }) {
        const options = {
            allSelectedText: "All",
            numberDisplayed: 1,
            maxHeight: 460,
            onInitialized: function() {
                $('label.checkbox').append('<span class="checkmark tw-absolute tw-h-[24px] tw-w-[24px] tw-border tw-rounded-[5px] tw-border-solid tw-border-gray-600 tw-left-0 tw-top-0 tw-mt-0"></span>');
            },
            buttonText: function(options) {
                if (options.length === 0) {
                    return buttonLabel;
                } else {
                    return `${buttonLabel} (${options.length})`;
                }
            },
        };
        $(`#${selectId}`).multiselect(options);
        $(`#${selectId}`).multiselect('select', page_info[selectedOptions]);
    }

    // Initialize all filter multiselects
    initMultiselect({
        selectId: 'therapists-specialties-select',
        selectedOptions: 'specialties',
        buttonLabel: 'Specialty'
    });
    initMultiselect({
        selectId: 'therapists-languages-select',
        selectedOptions: 'languages',
        buttonLabel: 'Language'
    });
    initMultiselect({
        selectId: 'therapists-identities-select',
        selectedOptions: 'identities',
        buttonLabel: 'Therapist Identity'
    });
    initMultiselect({
        selectId: 'therapists-preferences-select',
        selectedOptions: 'preferences',
        buttonLabel: 'Other traits'
    });

    // Apply filters button - for each filter, get selected values and update URL
    // Ex: ?specialties=Depression&languages=2
    $('#apply-filters').click(function() {
        function getSelectedValues(selector) {
            return $(selector + ' option:selected').map(function() {
                return $(this).val();
            }).get().join('_');
        }

        const filterSelectors = [
            { key: 'specialties', selector: '.specialties-div' },
            { key: 'languages', selector: '.languages-div' },
            { key: 'identities', selector: '.identities-div' },
            { key: 'preferences', selector: '.preferences-div' }
        ];

        let href = window.location.href;
        filterSelectors.forEach(filter => {
            const value = getSelectedValues(filter.selector);
            href = updateUrlParameter(href, filter.key, value);
        });
        window.location = href;
        updateFilterBtnText();
    });
});
